import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionIconStyle = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"type": "page",
			"properties": {
				"title": [
					[
						"Иконографика"
					]
				]
			},
			"content": [
				"a868ab06-c8c7-44e7-8c4d-937d0e1eaa49",
				"fc2417c7-8e26-4328-a94a-6c986f38d30c",
				"44ed4bb0-cf8d-402b-aa23-e206a8ed2616",
				"2eb7fdec-0d38-4a52-a149-8851385abcd3",
				"c96db3c7-c2c3-4ec9-815c-2d678d335c83",
				"37a3eea5-d645-4105-b190-720e6545fc12",
				"e740f3f9-bf4c-4d3c-9bf9-fc9ee7d4b6c5",
				"6a198830-d672-4bf9-ab7c-e412fa63de11",
				"2a1b4841-ff25-4bb5-a8fb-efc47fed8a27",
				"d2fe7cf9-1997-48f2-a343-129745213ca0",
				"0f3a2264-6d31-428b-a3bc-6d4b2bfa2573",
				"d1d71fe4-ad7c-41ce-afb9-1066425a1d39",
				"c5a453ff-886c-4092-9e9d-4c76d7e1e654",
				"569483a2-cdb0-4d80-892a-768021ccb3de",
				"2866b529-9a2f-435c-8a83-ea5af967c498",
				"07bfbd35-5cf6-4b1a-afc3-bfa0d8c16f2b",
				"7d0a5119-6747-4fe0-b45f-07b911a3b49a",
				"45bd13db-57a7-4cac-970e-cdc26ebf8bec",
				"c3478f37-5cde-4f51-b3b0-4c7329062cbb",
				"5f9e090a-58ff-4e85-a173-634edce3d2b1",
				"b5cc5b59-543c-440b-a1f2-8af4b6d55a81",
				"8b26f08b-bb6f-472d-9a0f-a8f4a9602422",
				"802e96b3-2568-4fa9-b9d6-dc51a12e4e04",
				"8c65a05e-756f-467e-acdb-a7474774e11c",
				"9794b137-bcbc-43a5-8cb5-b7bc427eb6b7",
				"b32db6ee-8d14-4d20-8287-c9e3f6d88688",
				"2ad72a8d-2a64-42ee-9c7e-a61cd8b66220",
				"0703f4a2-c89f-48aa-83cb-6ebcaec6d41a",
				"09d571d3-9b82-4619-86c7-82d1b9529af8",
				"bef63743-d6d8-4e65-92da-e5da7867d3be"
			],
			"format": {
				"copied_from_pointer": {
					"id": "830ce328-6356-4704-a838-7d71507a6a2e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"page_cover_position": 0.5
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"d03a9a5f-1f38-4c7b-84fa-ceecba18d78e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a868ab06-c8c7-44e7-8c4d-937d0e1eaa49",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/icon_style\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fc2417c7-8e26-4328-a94a-6c986f38d30c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Пиктограммы помогают сохранить узнаваемость продуктов. Мы используем общий набор иконок для продуктов VK. Это помогает сформировать у пользователя общее впечатление от работы с интерфейсами. Благодаря такому подходу мы можем легко интегрировать продукты друг в друга."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "81447951-0931-4f9d-a9c2-5ad88e5db654",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "44ed4bb0-cf8d-402b-aa23-e206a8ed2616",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки лежат в общем открытом репозиторий, и добавлять новые может любой дизайнер компании."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "07b8dac1-aee1-4d7b-8041-6a5b8862ce3c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2eb7fdec-0d38-4a52-a149-8851385abcd3",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://vkcom.github.io/icons/"
					]
				],
				"title": [
					[
						"VK Icons"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://vk.com/images/icons/favicons/fav_logo_2x.ico?6",
				"copied_from_pointer": {
					"id": "f457ea33-109d-4037-a436-28603f194a86",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c96db3c7-c2c3-4ec9-815c-2d678d335c83",
			"type": "image",
			"properties": {
				"size": [
					[
						"172.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/31542986-5443-4b6b-87e2-f8fd981c5331/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/31542986-5443-4b6b-87e2-f8fd981c5331/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "63d0c6d3-bdc0-4047-bbe8-23ddc070c60d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"file_ids": [
				"31542986-5443-4b6b-87e2-f8fd981c5331"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c96db3c7-c2c3-4ec9-815c-2d678d335c83.png"
		},
		{
			"id": "37a3eea5-d645-4105-b190-720e6545fc12",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки помогают восприятию информации, так как считываются быстрее текста. Они служат визуальными якорями на странице, их проще искать на экране, они помогают сориентироваться в интерфейсе. Если сомневаетесь в иконке, вероятно, её вообще не нужно использовать."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3022db2d-90ea-49e6-b109-0818e3a120fa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e740f3f9-bf4c-4d3c-9bf9-fc9ee7d4b6c5",
			"type": "header",
			"properties": {
				"title": [
					[
						"Размер иконок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ff2e394f-e888-40f4-8282-495103bbdfa2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6a198830-d672-4bf9-ab7c-e412fa63de11",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для продуктов в теме Paradigm основной размер иконок — 20, 24, 28. В редких случаях используются 12, 16, 32, 36 и 48, еще реже — 40. Под особые случаи допустимы и другие размеры."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "284f9b20-3ea8-4613-b73b-7b1c61b22a4b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2a1b4841-ff25-4bb5-a8fb-efc47fed8a27",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконка под каждый размер рисуется отдельно. Иногда возникает соблазн взять готовую иконку и изменить её размеры вручную — растянуть или уменьшить, но тогда она будет плохо выглядеть на старых мониторах и сильно отличаться от других иконок на экране по уровню детализации, толщине, оптическому весу и т.д., поэтому такие манипуляции строго запрещены."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2b698b9c-ffad-4864-96b9-336f7b84bd7e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d2fe7cf9-1997-48f2-a343-129745213ca0",
			"type": "column_list",
			"content": [
				"0715a33d-b4cd-4971-88c7-8ee08abaebf0",
				"faf8ad18-36fe-44ad-913f-303c4aa18277"
			],
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0f3a2264-6d31-428b-a3bc-6d4b2bfa2573",
			"type": "header",
			"properties": {
				"title": [
					[
						"Стиль иконок"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8449a0d6-88ec-45b3-a65a-99ad76ae98c2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d1d71fe4-ad7c-41ce-afb9-1066425a1d39",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Варианты"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7d034282-1ed0-42a5-ae06-4618e53e36b8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c5a453ff-886c-4092-9e9d-4c76d7e1e654",
			"type": "text",
			"properties": {
				"title": [
					[
						"В зависимости от специфики продукта мы используем Filled и Outline иконки. Outline основной вид который используется в большинстве случаев. Filled используются в тех случаях, когда outline не подходят, например в кнопках или когда важно показать активное состояние (поставили лайк, добавили в закладки и т.д.)."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e7773ce3-128c-4f03-8ba8-dea272d9d549",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "569483a2-cdb0-4d80-892a-768021ccb3de",
			"type": "column_list",
			"content": [
				"7ca3b847-636b-47ab-ad03-3bc1759e20a9",
				"8987f9ca-b2a8-435c-88c0-784e2a5e9a5e"
			],
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2866b529-9a2f-435c-8a83-ea5af967c498",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Цвет"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b05ac4ff-c13f-4663-af4c-0f3172542996",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "07bfbd35-5cf6-4b1a-afc3-bfa0d8c16f2b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки Paradigm одноцветны. В иконках, как и в остальных местах интерфейса, мы используем цвета из "
					],
					[
						"дизайн-токенов",
						[
							[
								"a",
								"/4f36900cbdf94b9cbdd5f6ab52b25931",
								true
							]
						]
					],
					[
						", которые синхронизированы с библиотекой в Figma."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b193ccdf-76c8-4c55-b85d-185dd9b87a97",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7d0a5119-6747-4fe0-b45f-07b911a3b49a",
			"type": "image",
			"properties": {
				"size": [
					[
						"44.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/50f1b0f6-8fdb-4a05-894e-46f7ffd7dea8/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/50f1b0f6-8fdb-4a05-894e-46f7ffd7dea8/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3076923076923077,
				"copied_from_pointer": {
					"id": "5a5874b7-3871-48b6-9dfc-00781fe278cb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"file_ids": [
				"50f1b0f6-8fdb-4a05-894e-46f7ffd7dea8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7d0a5119-6747-4fe0-b45f-07b911a3b49a.png"
		},
		{
			"id": "45bd13db-57a7-4cac-970e-cdc26ebf8bec",
			"type": "header",
			"properties": {
				"title": [
					[
						"Рекомендации по использованию"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d933b6ec-a681-497a-b208-e77caed8338c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c3478f37-5cde-4f51-b3b0-4c7329062cbb",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Используйте текст"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "10a3789a-d164-4e39-aef2-e0607be62d75",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5f9e090a-58ff-4e85-a173-634edce3d2b1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Существует несколько широко известных значков. Когда возможно, используйте метку или вспомогательный текст, чтобы облегчить понимание его значения."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f22869ed-ecae-46f0-be61-9e2e20a54684",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5cc5b59-543c-440b-a1f2-8af4b6d55a81",
			"type": "column_list",
			"content": [
				"f4cb186c-41dc-47aa-8b7b-e5e42a7d25fe",
				"87ccb1cc-3380-4b30-8e43-0c702ccbcbbd"
			],
			"format": {
				"copied_from_pointer": {
					"id": "29bae64a-f81a-433b-b5f5-607f05a5647b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8b26f08b-bb6f-472d-9a0f-a8f4a9602422",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не меняйте стиль иконки"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a8b9e016-a0f0-4438-b2e7-cca80f9cf016",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "802e96b3-2568-4fa9-b9d6-dc51a12e4e04",
			"type": "text",
			"properties": {
				"title": [
					[
						"Иконки в наборе имеют одинаковый вес, поэтому хорошо смотрятся вместе. Если изменить заливку на линии или изменить радиусы закруглений, это затруднит прочтение и отделит ее от набора."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "84dadd73-663d-41b0-96d5-94beaa0d13d2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8c65a05e-756f-467e-acdb-a7474774e11c",
			"type": "column_list",
			"content": [
				"c66ef5ad-724c-4959-a29e-f32068217d32",
				"287f4e0e-ae40-462c-abf9-7255b779998c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "3d26afa3-2b13-45a3-bd9f-797efc61cfce",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9794b137-bcbc-43a5-8cb5-b7bc427eb6b7",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Не смешивайте стили"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "32e8e361-8675-40c8-83bf-e45421523b5e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b32db6ee-8d14-4d20-8287-c9e3f6d88688",
			"type": "text",
			"properties": {
				"title": [
					[
						"Если иконки располагаются близко друг другу, в панели действий или в меню, не используйте пиктограмы разных стилей рядом."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "973bbf4d-93fa-4e92-97a4-22eb84bf18b9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2ad72a8d-2a64-42ee-9c7e-a61cd8b66220",
			"type": "column_list",
			"content": [
				"905072ec-c73c-4611-9554-2ef0ee74c92b",
				"7e127b50-dfad-4f38-8e55-6bcb9eedefd7"
			],
			"format": {
				"copied_from_pointer": {
					"id": "02c9011c-4465-49cc-9092-bb68d904e09b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0703f4a2-c89f-48aa-83cb-6ebcaec6d41a",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Используйте целенаправленно"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "d8062b0f-a6d3-467e-99b6-a5b1ea611e9e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "09d571d3-9b82-4619-86c7-82d1b9529af8",
			"type": "text",
			"properties": {
				"title": [
					[
						"Старайтесь не использовать иконки для украшения — это отвлекает от основного действия. Учитывайте окружающий контекст: когда иконки слишком близко расположены, они создают визуальный шум и путают."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "aa64eec6-8b33-4cac-a1d1-aec57e06492d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bef63743-d6d8-4e65-92da-e5da7867d3be",
			"type": "column_list",
			"content": [
				"cae4face-1c26-45de-8ef6-1dada16fabf6",
				"b48fe1a1-b27d-431f-91b0-abb84f61d8e4"
			],
			"format": {
				"copied_from_pointer": {
					"id": "bcd60d7d-14df-4c30-9a0c-500b369d5b6f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "da552996-155b-442f-9ecf-0bdce521a35e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4f36900c-bdf9-4b9c-bdd5-f6ab52b25931",
			"type": "page",
			"properties": {
				"title": [
					[
						"Дизайн-токены"
					]
				]
			},
			"content": [
				"be10fe04-5393-47b3-910d-8100999f95a7",
				"f327a5b7-eda0-477c-aae2-287378c28f5b",
				"84dd7ee8-8e25-478f-85da-d409c11a6ab2",
				"98b59c52-7205-4e9a-bdd4-9b9c342da4ca",
				"466ff8c9-a6a8-4c7c-89e0-3c0ee8557157",
				"ce097a2f-5f7e-4464-8ebb-bb576d21a769",
				"c21abd5c-eb57-41fe-b9ce-c27423c119b5",
				"bf7c4dc3-e3f7-40cd-a128-82b361928a4a",
				"fd663838-c7c7-4d50-9d55-b78fc59dee04",
				"ce335b4a-4f99-45ec-8003-dce5d6bf266d",
				"2b05a9c2-601a-4912-927b-dd0e490037b8",
				"b4b0812a-1fbd-4ff6-b172-fbdb797ba7c9",
				"58cf424e-215f-4f81-82d9-fd519d13db08",
				"a2d51385-9bd4-4aa8-bade-28738f475a45",
				"818c30a4-db2e-46b0-bfd6-2712d45d7182",
				"da9dee4f-3a58-43a1-a48f-0fa7f52a0fca"
			],
			"format": {
				"page_icon": "https://s3-us-west-2.amazonaws.com/secure.notion-static.com/ef92698d-7beb-4775-90d8-5ca24ab5ddda/android-chrome-512x512.png",
				"copied_from_pointer": {
					"id": "f957bd2b-554e-41a7-b1ad-659e6be3cefe",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "004a85dc-8148-4205-a9a9-300eec5bbc27",
			"parent_table": "block",
			"file_ids": [
				"ef92698d-7beb-4775-90d8-5ca24ab5ddda"
			],
			"space_id": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
		},
		{
			"id": "004a85dc-8148-4205-a9a9-300eec5bbc27",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"13aa5d2b-44d2-4e74-af6c-4c4c67eff097",
				"61a08802-d3e8-49bd-b352-a48ccc8ef0b9",
				"53870173-c431-40ca-b265-f9d6366b933a",
				"9f64f03f-ac18-45c6-9970-a32fac9938dd",
				"d6427946-1dc6-4531-9def-52b9ff20ff82",
				"eb5aca2e-4051-43e0-985c-9a7ea7e7f081",
				"830ce328-6356-4704-a838-7d71507a6a2e",
				"feaf69e1-4b36-4081-a9d1-72fd55b8b71b",
				"a7ebc923-836d-474c-b445-d1d279a9eda1",
				"4f36900c-bdf9-4b9c-bdd5-f6ab52b25931",
				"56bf3282-ca1b-4f86-8a0f-dfdf562499d9",
				"5259af59-2789-48b2-aeaf-022c5b6cb960",
				"f9555a25-defb-4c43-bfc7-344cc0dfd5c4",
				"cd339c0e-b2bf-4665-a149-28e647856b09",
				"dc765ffd-4471-4887-b95f-d37539b82d41",
				"b7f0f3c8-2794-4993-9295-a6048db6eb02",
				"06671d82-20c5-4c73-8728-a6a17f19325c",
				"cda85736-aecc-4708-b6ab-670608d41402"
			],
			"format": {
				"page_icon": "https://s3-us-west-2.amazonaws.com/secure.notion-static.com/c5515e3d-df2e-4105-902f-0be0c377f23d/android-chrome-512x512.png",
				"copied_from_pointer": {
					"id": "e3136478-1734-4ccb-b4e9-e3d629b78724",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "88e36bc7-0f69-4a9d-a386-055e55969d73",
			"parent_table": "block",
			"file_ids": [
				"c5515e3d-df2e-4105-902f-0be0c377f23d"
			],
			"space_id": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
		},
		{
			"id": "88e36bc7-0f69-4a9d-a386-055e55969d73",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"69bb45f0-17c7-493c-b924-0a58055bafda",
				"61dde941-aded-4dc4-8331-5304cd5adf01",
				"004a85dc-8148-4205-a9a9-300eec5bbc27",
				"95bf634c-aa68-4795-9764-128845664d87",
				"c6711e90-cc71-4426-a026-4272a455f4e2",
				"dd73f250-dcee-499f-9928-a64ae0f95839",
				"b5ea0d5c-6a88-4a9d-86a3-519945dbcfb5",
				"800c89f9-ecc1-48f3-9d9e-e71a15cf72c3",
				"ba18bb05-6455-4989-8870-8aa069763021",
				"2520d221-0ab7-4d49-8185-b5d5a17a4608",
				"c69693a4-2195-43cc-8247-565fb9e43a6b",
				"dc59e037-e91a-4556-a7b7-39e9c8062aa3",
				"b90b350a-d612-43e1-9c7f-4a91b0f3b582",
				"508b8f20-bff0-4f7c-811a-595bb2062bfc",
				"8c3dd291-b482-4a41-af17-d2e3314e7d96",
				"c0053a69-5f02-4aae-b5c4-45f80f96a101",
				"919f1c1e-cdef-4948-a099-45ccd12de76d",
				"f6769031-2c1e-43c4-8d42-cbc8a9868736",
				"23b782c2-0201-4889-86e2-a19530243e4e",
				"1d592e2d-0916-42f9-bf05-d16fde4bdc9d",
				"e822afdb-952a-4371-b809-9783f4f153e5",
				"0a299e6f-4b79-4c23-9ddc-037c4d0ef4e9",
				"b9a46337-62f9-4394-958b-2b9b5b7de114",
				"17f8723b-545c-4bfa-89df-1c362937f6f9",
				"31ff4903-767e-491a-8549-cd6b6feb8d98",
				"a281552d-23b2-43d8-902d-8cb80f45173f",
				"78112af9-d723-4312-8a0c-8316d19cd8af",
				"f55164be-cbbc-4e53-a77f-2cbda7e1880e",
				"fa2f3905-82c6-41fb-865b-53d586113d47",
				"b1b49aad-e3e0-4764-910d-accb03a3b32b",
				"eb6afd99-a27b-4c95-bd45-cc1e6f7bfa4b",
				"3a5686b3-92bf-4602-92eb-621452134206",
				"1a6a7b9f-8769-4bf2-8c28-2896bc624c04",
				"e18f3e2d-1363-40c5-b559-b18b473a94a7"
			],
			"format": {
				"page_icon": "🦾",
				"page_section_visibility": {
					"comments": "section_hide",
					"backlinks": "section_collapsed",
					"margin_comments": "inline"
				}
			},
			"parent_id": "46b64673-cce7-47b6-aa86-56570b225197",
			"parent_table": "team",
			"space_id": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
		},
		{
			"id": "0715a33d-b4cd-4971-88c7-8ee08abaebf0",
			"type": "column",
			"content": [
				"32014390-639a-464f-a1d1-f6f4a5303fcf",
				"287bf11d-02f9-4968-9d2d-37afee60a804"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "d2fe7cf9-1997-48f2-a343-129745213ca0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "faf8ad18-36fe-44ad-913f-303c4aa18277",
			"type": "column",
			"content": [
				"2351ef78-25ac-4059-96f4-e8969e4bed72",
				"f1e85c3d-f460-487e-8474-fcc3e144e3ce"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "d2fe7cf9-1997-48f2-a343-129745213ca0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "32014390-639a-464f-a1d1-f6f4a5303fcf",
			"type": "image",
			"properties": {
				"size": [
					[
						"139.9KB"
					]
				],
				"title": [
					[
						"1.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/49ccb26a-188c-4cb0-b2bb-a01dacacd692/1.png"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/49ccb26a-188c-4cb0-b2bb-a01dacacd692/1.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.535,
				"block_preserve_scale": true
			},
			"parent_id": "0715a33d-b4cd-4971-88c7-8ee08abaebf0",
			"parent_table": "block",
			"file_ids": [
				"49ccb26a-188c-4cb0-b2bb-a01dacacd692"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/32014390-639a-464f-a1d1-f6f4a5303fcf.png"
		},
		{
			"id": "287bf11d-02f9-4968-9d2d-37afee60a804",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иконки под все размеры рисуются отдельно"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8449a0d6-88ec-45b3-a65a-99ad76ae98c2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0715a33d-b4cd-4971-88c7-8ee08abaebf0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2351ef78-25ac-4059-96f4-e8969e4bed72",
			"type": "image",
			"properties": {
				"size": [
					[
						"165.4KB"
					]
				],
				"title": [
					[
						"2.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/70860c21-17e9-4dae-915e-206201f315de/2.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/70860c21-17e9-4dae-915e-206201f315de/2.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.535,
				"block_preserve_scale": true
			},
			"parent_id": "faf8ad18-36fe-44ad-913f-303c4aa18277",
			"parent_table": "block",
			"file_ids": [
				"70860c21-17e9-4dae-915e-206201f315de"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2351ef78-25ac-4059-96f4-e8969e4bed72.png"
		},
		{
			"id": "f1e85c3d-f460-487e-8474-fcc3e144e3ce",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иконка 16 растянута на другие размеры"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background"
			},
			"parent_id": "faf8ad18-36fe-44ad-913f-303c4aa18277",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7ca3b847-636b-47ab-ad03-3bc1759e20a9",
			"type": "column",
			"content": [
				"fa6dd286-70f5-4135-a947-6b7950e38c6c"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "569483a2-cdb0-4d80-892a-768021ccb3de",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8987f9ca-b2a8-435c-88c0-784e2a5e9a5e",
			"type": "column",
			"content": [
				"9ee7f2e4-5efc-4373-8715-f27fa2e3368c"
			],
			"format": {
				"column_ratio": 0.5
			},
			"parent_id": "569483a2-cdb0-4d80-892a-768021ccb3de",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa6dd286-70f5-4135-a947-6b7950e38c6c",
			"type": "image",
			"properties": {
				"size": [
					[
						"179.6KB"
					]
				],
				"title": [
					[
						"icons.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/07a3c559-6473-4822-a3c4-646de07501d5/icons.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/07a3c559-6473-4822-a3c4-646de07501d5/icons.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.535,
				"block_preserve_scale": true
			},
			"parent_id": "7ca3b847-636b-47ab-ad03-3bc1759e20a9",
			"parent_table": "block",
			"file_ids": [
				"07a3c559-6473-4822-a3c4-646de07501d5"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fa6dd286-70f5-4135-a947-6b7950e38c6c.png"
		},
		{
			"id": "9ee7f2e4-5efc-4373-8715-f27fa2e3368c",
			"type": "image",
			"properties": {
				"size": [
					[
						"137.5KB"
					]
				],
				"title": [
					[
						"icons1.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ba0c9968-533a-45f5-925c-2e02d89967f0/icons1.png"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ba0c9968-533a-45f5-925c-2e02d89967f0/icons1.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.535,
				"block_preserve_scale": true
			},
			"parent_id": "8987f9ca-b2a8-435c-88c0-784e2a5e9a5e",
			"parent_table": "block",
			"file_ids": [
				"ba0c9968-533a-45f5-925c-2e02d89967f0"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9ee7f2e4-5efc-4373-8715-f27fa2e3368c.png"
		},
		{
			"id": "f4cb186c-41dc-47aa-8b7b-e5e42a7d25fe",
			"type": "column",
			"content": [
				"fad6adca-dd96-4794-9d0c-1efa52ed19fa",
				"309caaed-085c-4f17-95bf-f2d02cb13cea"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "7e9c99df-5518-4b64-a58a-517427e4d9f8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "b5cc5b59-543c-440b-a1f2-8af4b6d55a81",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "87ccb1cc-3380-4b30-8e43-0c702ccbcbbd",
			"type": "column",
			"content": [
				"16d2d87d-6144-45af-8c03-985ba361a4f9",
				"601a1e36-1061-46b9-8244-0132d09850d2"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "14104264-98d7-4362-81be-b2c50a48763e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "b5cc5b59-543c-440b-a1f2-8af4b6d55a81",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fad6adca-dd96-4794-9d0c-1efa52ed19fa",
			"type": "image",
			"properties": {
				"size": [
					[
						"73.9KB"
					]
				],
				"title": [
					[
						"01.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/53fe3ce9-c899-4f76-85c5-9445fc927705/01.png"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/53fe3ce9-c899-4f76-85c5-9445fc927705/01.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5235,
				"block_preserve_scale": true
			},
			"parent_id": "f4cb186c-41dc-47aa-8b7b-e5e42a7d25fe",
			"parent_table": "block",
			"file_ids": [
				"53fe3ce9-c899-4f76-85c5-9445fc927705"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/fad6adca-dd96-4794-9d0c-1efa52ed19fa.png"
		},
		{
			"id": "309caaed-085c-4f17-95bf-f2d02cb13cea",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Используйте иконки вместе с текстом"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9c85d72e-7d47-409a-9cd0-cbede013c131",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f4cb186c-41dc-47aa-8b7b-e5e42a7d25fe",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "16d2d87d-6144-45af-8c03-985ba361a4f9",
			"type": "image",
			"properties": {
				"size": [
					[
						"61.0KB"
					]
				],
				"title": [
					[
						"02.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d1856a37-b437-4a6c-ad06-f41d896ab442/02.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d1856a37-b437-4a6c-ad06-f41d896ab442/02.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5235,
				"block_preserve_scale": true
			},
			"parent_id": "87ccb1cc-3380-4b30-8e43-0c702ccbcbbd",
			"parent_table": "block",
			"file_ids": [
				"d1856a37-b437-4a6c-ad06-f41d896ab442"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/16d2d87d-6144-45af-8c03-985ba361a4f9.png"
		},
		{
			"id": "601a1e36-1061-46b9-8244-0132d09850d2",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иконка без подписи может быть непонятной"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "956d79e2-93b2-49b1-8417-577642341c30",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "87ccb1cc-3380-4b30-8e43-0c702ccbcbbd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c66ef5ad-724c-4959-a29e-f32068217d32",
			"type": "column",
			"content": [
				"7a69ce07-6a7a-42c4-a251-2b4b912b7ee1",
				"e1074ee3-8899-4b43-88b2-588b31a75ac7"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "d77ba5e0-4f96-4a9e-a75b-3da0089a44d4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8c65a05e-756f-467e-acdb-a7474774e11c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "287f4e0e-ae40-462c-abf9-7255b779998c",
			"type": "column",
			"content": [
				"57594459-8ff4-4281-b397-93d9c87b7340",
				"231eb50b-3688-4191-b1bb-b50e9c922865"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "a8ade667-fd6c-42c1-a90c-aba585be72bc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8c65a05e-756f-467e-acdb-a7474774e11c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7a69ce07-6a7a-42c4-a251-2b4b912b7ee1",
			"type": "image",
			"properties": {
				"size": [
					[
						"107.3KB"
					]
				],
				"title": [
					[
						"03.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c7b74208-deef-499f-ab1e-63943812e16e/03.png"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c7b74208-deef-499f-ab1e-63943812e16e/03.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5235,
				"block_preserve_scale": true
			},
			"parent_id": "c66ef5ad-724c-4959-a29e-f32068217d32",
			"parent_table": "block",
			"file_ids": [
				"c7b74208-deef-499f-ab1e-63943812e16e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/7a69ce07-6a7a-42c4-a251-2b4b912b7ee1.png"
		},
		{
			"id": "e1074ee3-8899-4b43-88b2-588b31a75ac7",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иконки смотрятся аккуратно и гармонично"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "9f264738-b03d-425f-ba2d-d279573faa41",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "c66ef5ad-724c-4959-a29e-f32068217d32",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "57594459-8ff4-4281-b397-93d9c87b7340",
			"type": "image",
			"properties": {
				"size": [
					[
						"106.8KB"
					]
				],
				"title": [
					[
						"04.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3dcb524d-cdbd-4d6e-a0e9-00ef63eed14a/04.png"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3dcb524d-cdbd-4d6e-a0e9-00ef63eed14a/04.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5235,
				"block_preserve_scale": true
			},
			"parent_id": "287f4e0e-ae40-462c-abf9-7255b779998c",
			"parent_table": "block",
			"file_ids": [
				"3dcb524d-cdbd-4d6e-a0e9-00ef63eed14a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/57594459-8ff4-4281-b397-93d9c87b7340.png"
		},
		{
			"id": "231eb50b-3688-4191-b1bb-b50e9c922865",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Измененные иконки смотрятся неопрятно"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "3c65e06e-97c6-40b5-9801-e6ac7f077d3a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "287f4e0e-ae40-462c-abf9-7255b779998c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "905072ec-c73c-4611-9554-2ef0ee74c92b",
			"type": "column",
			"content": [
				"bcf58a81-ce1a-4b1d-b2ec-4eeaa2c33dd4",
				"4918350d-daa1-4d87-9486-5a77575041c0"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "28eda30f-4767-4532-8365-5e63752849b1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2ad72a8d-2a64-42ee-9c7e-a61cd8b66220",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7e127b50-dfad-4f38-8e55-6bcb9eedefd7",
			"type": "column",
			"content": [
				"e1ea2564-b6f4-4842-b516-de03b9165d1c",
				"157dabea-1850-4387-bb86-781a7d09b0d1"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "c4d546eb-853a-425a-980d-77a2ecb699c1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2ad72a8d-2a64-42ee-9c7e-a61cd8b66220",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bcf58a81-ce1a-4b1d-b2ec-4eeaa2c33dd4",
			"type": "image",
			"properties": {
				"size": [
					[
						"136.8KB"
					]
				],
				"title": [
					[
						"05.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5fc5bb23-74ea-498d-a44c-e8762ee48dad/05.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5fc5bb23-74ea-498d-a44c-e8762ee48dad/05.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.535,
				"block_preserve_scale": true
			},
			"parent_id": "905072ec-c73c-4611-9554-2ef0ee74c92b",
			"parent_table": "block",
			"file_ids": [
				"5fc5bb23-74ea-498d-a44c-e8762ee48dad"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/bcf58a81-ce1a-4b1d-b2ec-4eeaa2c33dd4.png"
		},
		{
			"id": "4918350d-daa1-4d87-9486-5a77575041c0",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иконки находятся в одном контексте и консистентны"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8e294d2f-ba07-49ad-915a-b4922dd34dab",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "905072ec-c73c-4611-9554-2ef0ee74c92b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e1ea2564-b6f4-4842-b516-de03b9165d1c",
			"type": "image",
			"properties": {
				"size": [
					[
						"123.0KB"
					]
				],
				"title": [
					[
						"06.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/82578034-5932-49f3-b130-9362adcd25fc/06.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/82578034-5932-49f3-b130-9362adcd25fc/06.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.535,
				"block_preserve_scale": true
			},
			"parent_id": "7e127b50-dfad-4f38-8e55-6bcb9eedefd7",
			"parent_table": "block",
			"file_ids": [
				"82578034-5932-49f3-b130-9362adcd25fc"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e1ea2564-b6f4-4842-b516-de03b9165d1c.png"
		},
		{
			"id": "157dabea-1850-4387-bb86-781a7d09b0d1",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иконки разных стилей вместе"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "d0b9b8f5-894f-4e2f-8f6d-50efae6a66f2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7e127b50-dfad-4f38-8e55-6bcb9eedefd7",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cae4face-1c26-45de-8ef6-1dada16fabf6",
			"type": "column",
			"content": [
				"c5a3c165-487c-402b-8473-9f92961f5955"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "b9d61dd7-e7f4-402c-9dd7-32bf49c73a17",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "bef63743-d6d8-4e65-92da-e5da7867d3be",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b48fe1a1-b27d-431f-91b0-abb84f61d8e4",
			"type": "column",
			"content": [
				"ca21f4e8-bf2e-436c-b46e-05d0b81ccee8",
				"71526e5e-2448-40f6-97e6-50c8cd6c2951"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "00fa7681-8456-470f-b85b-a3f6b202cae5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "bef63743-d6d8-4e65-92da-e5da7867d3be",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c5a3c165-487c-402b-8473-9f92961f5955",
			"type": "image",
			"properties": {
				"size": [
					[
						"74.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c99944ee-7ee1-4fc0-8fd0-0b101d8f7ad8/c6770313-208e-4c20-a9b3-e1049daedb12.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 320,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c99944ee-7ee1-4fc0-8fd0-0b101d8f7ad8/c6770313-208e-4c20-a9b3-e1049daedb12.png",
				"original_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3f4fe568-ac05-4d20-83b3-a23a3fef019d/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8690000000000001,
				"copied_from_pointer": {
					"id": "706068eb-10f0-47d5-ac25-0104647839ff",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"image_edit_metadata": {
					"crop": {
						"x": 0,
						"y": 0,
						"unit": "%",
						"width": 100,
						"height": 100
					},
					"mask": "None"
				},
				"block_preserve_scale": true
			},
			"parent_id": "cae4face-1c26-45de-8ef6-1dada16fabf6",
			"parent_table": "block",
			"file_ids": [
				"3f4fe568-ac05-4d20-83b3-a23a3fef019d",
				"c99944ee-7ee1-4fc0-8fd0-0b101d8f7ad8"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c5a3c165-487c-402b-8473-9f92961f5955.png"
		},
		{
			"id": "ca21f4e8-bf2e-436c-b46e-05d0b81ccee8",
			"type": "image",
			"properties": {
				"size": [
					[
						"78.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/85235dc6-9283-476e-b14d-7b10e0751f56/f4fc655c-f375-4494-82ec-73bf2740afde.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 320,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/85235dc6-9283-476e-b14d-7b10e0751f56/f4fc655c-f375-4494-82ec-73bf2740afde.png",
				"original_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/afb0d7d4-e47c-4318-b3f8-d36c9c29f008/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8690000000000001,
				"copied_from_pointer": {
					"id": "b524f96e-3dc2-44a1-9583-422e41dbd247",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"image_edit_metadata": {
					"crop": {
						"x": 0,
						"y": 0,
						"unit": "%",
						"width": 100,
						"height": 100
					},
					"mask": "None"
				},
				"block_preserve_scale": true
			},
			"parent_id": "b48fe1a1-b27d-431f-91b0-abb84f61d8e4",
			"parent_table": "block",
			"file_ids": [
				"afb0d7d4-e47c-4318-b3f8-d36c9c29f008",
				"85235dc6-9283-476e-b14d-7b10e0751f56"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ca21f4e8-bf2e-436c-b46e-05d0b81ccee8.png"
		},
		{
			"id": "71526e5e-2448-40f6-97e6-50c8cd6c2951",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "745372e6-d741-4930-b604-b476516cb18e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "b48fe1a1-b27d-431f-91b0-abb84f61d8e4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Размер иконок",
			"id": "e740f3f9-bf4c-4d3c-9bf9-fc9ee7d4b6c5"
		},
		{
			"title": "Стиль иконок",
			"id": "0f3a2264-6d31-428b-a3bc-6d4b2bfa2573"
		},
		{
			"title": "Рекомендации по использованию",
			"id": "45bd13db-57a7-4cac-970e-cdc26ebf8bec"
		}
	]
}} />
);

export default NotionIconStyle;
